// @ts-strict-ignore
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, DataListItem } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import { Channel } from 'types/channels'
import { ContactCase } from 'types/contacts'

export type ChannelPaymentSidePanelBodyProps = {
  channel: Channel
  contactCase: ContactCase
}

export const ChannelPaymentSidePanelBody = ({
  channel,
  contactCase,
}: ChannelPaymentSidePanelBodyProps) => {
  const { t } = useTranslation()

  return (
    <Box flexCol gapY={12}>
      <DataListItem
        id="payment-in-amount-received"
        testId="payment-in-amount-received"
        title={t('transactions.sideBar.paymentInAmountReceived')}
        body={`${contactCase?.amount} ${contactCase?.currencyCode}`}
      />
      <DataListItem
        id="receiving-wallet"
        testId="receiving-wallet"
        title={t('transactions.sideBar.receivingWallet')}
        body={`${channel?.walletDescription}`}
      />
      <DataListItem
        id="channel-reference"
        testId="channel-reference"
        title={t('transactions.sideBar.channelReference')}
        body={ellipseMiddleText(channel?.reference, 20, 10)}
        copyText={channel?.reference}
      />
      <DataListItem
        id="uuid"
        testId="uuid"
        title={t('transactions.sideBar.uuid')}
        body={ellipseMiddleText(channel?.uuid, 20, 10)}
        copyText={channel?.uuid}
      />
      <DataListItem
        id="hash"
        testId="hash"
        title={t('transactions.sideBar.hash')}
        body={ellipseMiddleText(contactCase?.hash, 20, 10)}
        copyText={contactCase?.hash}
      />
    </Box>
  )
}
